export const isCenterInLocation = (center = { locations: [] }, location = '') =>
  center?.locations?.includes(location) ||
  center?.locations?.some((loc) => loc?.title === location)

export const isCenterInUnitedStates = (center = { locations: [] }) =>
  isCenterInLocation(center, 'United States')
